import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'fa', name: 'فارسی', flag: '🇮🇷' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ber', name: 'Tamaziɣt', flag: 'ⵣ' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' }
];

const LanguageSelector = ({ value, onChange }) => {
  const selectedLang = LANGUAGES.find(l => l.code === value) || LANGUAGES[0];

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className="w-[180px] bg-sky-500/10 border-sky-400/30 text-sky-300 hover:bg-sky-400/15"
        data-testid="language-selector"
      >
        <div className="flex items-center gap-2">
          <Globe size={16} />
          <SelectValue>
            <span>{selectedLang.flag} {selectedLang.name}</span>
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent className="bg-[var(--bg-elev-1)] border-[var(--line)]">
        {LANGUAGES.map((lang) => (
          <SelectItem
            key={lang.code}
            value={lang.code}
            className="text-[var(--text-primary)] hover:bg-sky-500/10 cursor-pointer"
          >
            <span>{lang.flag} {lang.name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
